<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Pencarian Jadwal Wawancara
      </h5>
    </b-card-header>
    <b-card-body>
      <!-- <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Hak Akses</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="roleFilter"
            :options="roleOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:roleFilter', val)"
          />
        </b-col>
      </b-row> -->
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Nomor Ujian</label>
          <b-form-input 
            v-model="filter.nomor_ujian"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Nama Peserta</label>
          <b-form-input 
            v-model="filter.nama_peserta"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Email Peserta</label>
          <b-form-input 
            v-model="filter.email"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-1"
        >
          <label>Nomor Telepon</label>
          <b-form-input 
            v-model="filter.nomor_telepon"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-1"
        >
          <label>Pewawancara</label>
          <b-form-input 
            v-model="filter.pewawancara"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-1"
        >
          <label>Tanggal</label>
          <b-form-datepicker v-model="filter.tanggal" locale="id"></b-form-datepicker>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
          <b-button variant="primary" @click="cari()" class="mr-1">Cari</b-button>
          <!-- <b-button variant="secondary" @click="hapusFilter()">Hapus Filter</b-button> -->
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,BButton, BFormDatepicker
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormInput,
    BButton,
    BFormDatepicker,
  },
  data() {
    return {
      filter: {},
      count: 0,
    }
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  methods: {
    hapusFilter(){
      this.filter = {}
      this.count += 1
      this.$emit('update:dataFilter', this.filter)
      this.$emit('update:triggerFilter', this.count)
    },
    cari()
    {
      this.count += 1
      this.$emit('update:dataFilter', this.filter)
      this.$emit('update:triggerFilter', this.count)
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
